import { BLOCKS } from 'constants';

/**
 * Parse and format the wagtail's page content type to recognizable name
 * in the client app.
 *
 * @param {string} contentType content type of the wagtail page
 */
const getTemplateName = (contentType) => {
  const [, template] = contentType.split('.');
  return template;
};

const findByBlockType = (arr, blockType) => {
  return (arr || []).find((el) => blockType in BLOCKS && el.blockType === BLOCKS[blockType]);
};

export default getTemplateName;
export { findByBlockType };
